import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { DynamicTexts as DynamicTextsContents } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import DynamicTexts from "@/ui/organisms/DynamicTexts"

export interface SanityDynamicTextsProps {
  content: DynamicTextsContents
}

const SanityDynamicTexts = ({ content }: SanityDynamicTextsProps) => {
  return (
    <BlokWrapper contents={content} menuColor="dark">
      <DynamicTexts
        separator={
          content.separatorIcon ? (
            <SanityImageField asset={content.separatorIcon.asset} />
          ) : undefined
        }
        blocks={
          content.blocks
            ?.map((x) => ({
              texts:
                x.texts
                  ?.filter((text) => text.text)
                  .map((text) => text.text!) ?? [],
            }))
            .filter((x) => x.texts.length > 0) ?? []
        }
        horizontalBreakpoint={content.horizontalBreakpoint}
      />
    </BlokWrapper>
  )
}

export default SanityDynamicTexts
